<div class="card-body" *ngIf="{linkTransferPreview: linkTransferPreview$ | async, al2Users: al2Users$ | async, al3Companies: al3Companies$ | async} as context">
	<div *ngIf="!context.al2Users">Loading...</div>
	<ng-container *ngIf="context.al2Users">
		<div class="header-bar">
			<div class="users-selection">
				<div class="user-select-lookup">
					<label>AL2 User</label>
					<dx-lookup [dataSource]="context.al2Users" displayExpr="name" valueExpr="id" [(ngModel)]="al2userId" (onValueChanged)="onAL2UserChange($event)"></dx-lookup>
				</div>
				<i class="far fa-arrow-right"></i>
				<div class="user-select-lookup">
					<label>AL3 Company</label>
					<dx-lookup [dataSource]="context.al3Companies" displayExpr="name" valueExpr="id" [(ngModel)]="al3companyId" (onValueChanged)="onAL3CompanyChange($event)"></dx-lookup>
				</div>
			</div>
			<div class="transfer-links-button-container">
				<button *ngIf="context.linkTransferPreview" class="btn btn-sm btn-warning transfer-links-button" [disabled]="context.linkTransferPreview.length === 0" (click)="transferLinks(undefined)">Transfer all of this user's links</button>
			</div>
		</div>
		<div class="preview-container">
			<dx-data-grid *ngIf="context.linkTransferPreview" [dataSource]="context.linkTransferPreview" height="100%">
				<dxo-selection mode="none"></dxo-selection>
				<dxo-filter-row [visible]="true"></dxo-filter-row>

				<dxi-column dataField="description"></dxi-column>
				<dxi-column dataField="fromLinkTemplate"></dxi-column>
				<dxi-column dataField="toLinkTemplate"></dxi-column>
				<dxi-column dataField="numberOfSettings"></dxi-column>
				<dxi-column dataField="numberOfMappings"></dxi-column>

				<dxi-column cellTemplate="actionsCellTemplate" [allowResizing]="false" [fixed]="true" fixedPosition="right" dataType="string" width="100px"></dxi-column>

				<div class="actions-cell" *dxTemplate="let d of 'actionsCellTemplate'">
					<button class="btn btn-sm btn-warning transfer-link-button" (click)="transferLinks([d.data.id])">Transfer link</button>
				</div>
			</dx-data-grid>
			<div *ngIf="!context.linkTransferPreview" class="select-message">Please select an AL2 user and AL3 company</div>
		</div>

		<!-- New Section for Miscellaneous Features -->
		<div class="miscellaneous-section">
			<h5 class="section-title">Miscellaneous Link Transfer Features</h5>
			<div class="section-content">
				<!-- Example Buttons -->
				<button class="btn btn-primary" (click)="updatePurchaseOrderCache(undefined)">Update purchase order cache</button>
			</div>
		</div>
	</ng-container>
</div>

<a id="linkanchor"></a>
